import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'developer-compass',
});

export const marketplaceRouteRef = createSubRouteRef({
  id: 'developer-compass.marketplace',
  parent: rootRouteRef,
  path: '/marketplace',
});

export const checkoutRouteRef = createSubRouteRef({
  id: 'developer-compass.checkout',
  parent: rootRouteRef,
  path: '/checkout',
});

export const licensesRouteRef = createSubRouteRef({
  id: 'developer-compass.licenses',
  parent: rootRouteRef,
  path: '/licenses',
});

export const licenseDetailRouteRef = createSubRouteRef({
  id: 'developer-compass.licenses.detail',
  parent: rootRouteRef,
  path: '/licenses/:licenseId',
});

export const licenseBillingUpdateRouteRef = createSubRouteRef({
  id: 'developer-compass.licenses.billing-update',
  parent: rootRouteRef,
  path: '/licenses/billing-update',
});
